export const sidebarMenuList = [
  {
    id: 'detail-dasar',
    title: 'Detail Dasar',
    subtitle: 'Informasi Dasar SO',
  },
  {
    id: 'detail-produk',
    title: 'Detail Produk',
    subtitle: 'List produk yang akan dikirim',
  },
]
